/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Link } from '@insticator/insticator-ui'; // iui-material
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/signup/signup_styles';



/* ========== ~~~~~~~~~~ CTA : SIGN UP ~~~~~~~~~~ ========== */
const SignUpCTA = (props) => {
	return (
		<div className={`cta signupcta ${props.classes.signupcta}`}>
	        <p>Don't have an account yet? <Link type={`external`} action={`${url.company}/demo-contact-form/`} text={`Request Demo`} /></p>
	    </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SignUpCTA);
